export interface ILucky{
   type: LuckyType,
   value: number
 }
 export enum LuckyType {
   ENERGY = 'ENERGY',
   EMPTY_NET_10 = 'EMPTY_NET_10',
   EMPTY_NET_25 = 'EMPTY_NET_25',
   OVI_FLEX_100 = 'OVI_FLEX_100',
 }

export enum SpriteConfigNameLucky{
    wheel = 'wheel',
    stick = 'stick',
    center = 'center',
}
export interface AreaConfigLucky {
    width: number;
    height: number;
    baseWidth: number;
    baseHeight: number;
    x: number;
    y: number;
}

export interface SpriteConfigLucky {
    name: SpriteConfigNameLucky;
    width: number;
    height: number;
    x: number;
    y: number;
    anchor: number;
    image: string;
    baseWidth: number;
    baseHeight: number;
}
